<script setup>
import { defineEmits, defineProps, ref } from "vue";
import PaymentMethod from "@/components/payment/PaymentMethod.vue";
import PaymentDetail from "@/components/payment/PaymentDetail.vue";
import { formatMoney } from "@/utils/money.ts";
import dayjs from "dayjs";

const { payments, search } = defineProps({
  payments: {
    type: Array,
    default: () => [],
  },
  search: {
    type: String,
    default: "",
  },
});
const emit = defineEmits([
  'payment:updated'
]);
const paymentDetail = ref(null);

const onPaymentUpdated = (payment) => {
  emit('payment:updated', payment);
};

const onPaymentDetailClose = () => {
  paymentDetail.value = null;
};

</script>

<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <tbody>
      <tr v-for="payment in payments">
        <slot name="line-prepend" :payment="payment"></slot>
        <td class="">
          <span :class="['d-block', !payment.paid_amount || (payment.due_amount.amount !== payment.paid_amount.amount) ? 'text-danger' : '']">
            <a href @click.prevent="paymentDetail = payment">
              {{ formatMoney(payment.paid_amount) }}
            </a>
          </span>
          <small class="text-muted d-block">
            {{ payment.type.label }}
          </small>
        </td>
        <td  class="align-middle">
          <span :class="[
            'badge',
            ['succeeded'].includes(payment.status) ? 'badge-success': '',
            ['requires_capture'].includes(payment.status) ? 'badge-info': '',
            ['pending'].includes(payment.status) ? 'badge-warning': '',
            payment.status === 'failed' || payment.status === 'canceled' ? 'badge-danger': '',
          ]">
          {{ payment.status }}
          </span>
        </td>
        <td  class="align-middle">
          <strong class="d-block">
            {{ payment.mode.label }}
          </strong>
          <div class="d-none d-md-block">
            <PaymentMethod v-if="payment.mode.value === 'stripe'" :payment-method="payment.payment_method" />
          </div>
        </td>
        <td class="text-muted d-none d-lg-table-cell align-middle">
          <text-highlight :query="search" :splitBySpace="true">
            {{ payment.reference ?? "N/A" }}
          </text-highlight>
        </td>
        <td class="text-muted d-none d-lg-table-cell align-middle">
          {{ dayjs(payment.created_at).format('lll') }}
        </td>
        <td class="align-middle">
          <a href @click.prevent="paymentDetail = payment">
            <i class="fa fa-eye ml-1"></i>
            {{ $t("Details") }}
          </a>
        </td>
      </tr>
      </tbody>
    </table>

    <PaymentDetail
      :payment="paymentDetail"
      @close="onPaymentDetailClose"
      @payment:updated="onPaymentUpdated"
    />
  </div>
</template>
